const ItemGroup = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-group" */ '@/pages/base-info/order-properties/item-group/index.vue'
  )
const CreateItemGroup = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-group" */ '@/pages/base-info/order-properties/item-group/create.vue'
  )
const EditItemGroup = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-group" */ '@/pages/base-info/order-properties/item-group/edit.vue'
  )

export default {
  path: 'item-group',
  meta: {
    label: 'itemGroup',
    auth: 'itemGroup'
  },
  component: {
    name: 'ItemGroup',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoPropertyItemGroup',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ItemGroup
    },
    {
      name: 'BaseInfoCreatePropertyItemGroup',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateItemGroup
    },
    {
      name: 'BaseInfoEditPropertyItemGroup',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditItemGroup,
      props: true
    }
  ]
}
